"use client";

import { Link } from "@/i18n/navigation";
import { useState } from "react";
import { capitalize } from "@/helpers/capitalize";
import { getLocale } from "next-intl/server";
import moment from "moment-timezone";
import { useSession } from "next-auth/react";
import { useLocale, useTranslations } from "next-intl";

export default function EventsComponent() {
    const locale = useLocale();
    const t = useTranslations();
    const { data: session } = useSession();
    const [events, setEvents] = useState([]);

    return (
        <>
            {events.length == 0 && <p>{t("events_noEvents")}</p>}
            <div className="flex flex-col gap-5">
                {events.map((event) => (
                    <Link
                        href={`/events/${event.slug}?source=events`}
                        key={event.id}
                        className="text-black hover:text-black"
                    >
                        <div className="border rounded-lg p-5 hover:border-excitationRed duration-150 hover:bg-gray-100">
                            <h3 className="text-xl font-bold mb-5">
                                {event.title}
                            </h3>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: event.description,
                                }}
                            ></div>
                            {event.eventDates.length > 0 && (
                                <>
                                    <h4 className="text-lg font-bold mt-5">
                                        {event.eventDates.length > 1
                                            ? t("events_future")
                                            : t("events_date")}
                                    </h4>
                                    <div className="flex flex-col md:flex-row md:justify-between mt-1">
                                        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-2 w-full">
                                            {event.eventDates.map((date) => (
                                                <div
                                                    className="border border-excitationRed rounded-xl p-5 flex flex-col col-span-1"
                                                    key={date.id}
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="1.9em"
                                                        height="1.9em"
                                                        viewBox="0 0 24 24"
                                                        className="text-excitationOrange mb-2"
                                                    >
                                                        <g
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="1.5"
                                                        >
                                                            <path d="M2 12c0-3.771 0-5.657 1.172-6.828C4.343 4 6.229 4 10 4h4c3.771 0 5.657 0 6.828 1.172C22 6.343 22 8.229 22 12v2c0 3.771 0 5.657-1.172 6.828C19.657 22 17.771 22 14 22h-4c-3.771 0-5.657 0-6.828-1.172C2 19.657 2 17.771 2 14v-2Z"></path>
                                                            <path
                                                                strokeLinecap="round"
                                                                d="M7 4V2.5M17 4V2.5M2.5 9h19"
                                                            ></path>
                                                        </g>
                                                    </svg>
                                                    <div className="font-bold">
                                                        {capitalize(
                                                            moment
                                                                .utc(date.date)
                                                                .tz(
                                                                    session
                                                                        ? session
                                                                              .user
                                                                              .timezone
                                                                        : "Europe/Paris",
                                                                )
                                                                .locale(locale)
                                                                .calendar(
                                                                    null,
                                                                    {
                                                                        sameDay:
                                                                            t("BookedEvent_today", { date: "HH:mm" }),
                                                                        nextDay:
                                                                            t("BookedEvent_tomorrow", { date: "HH:mm" }),
                                                                        nextWeek:
                                                                            t("BookedEvent_nextWeek", { day: "dddd", hour: "HH:mm" }),
                                                                        lastDay:
                                                                            t("BookedEvent_yesterday", { date: "HH:mm" }),
                                                                        lastWeek:
                                                                            "dddd",
                                                                        sameElse:
                                                                            "ddd DD MMMM HH:mm",
                                                                    },
                                                                ),
                                                        )}
                                                    </div>
                                                    <div className="uppercase text-xs text-excitationRed">
                                                        {t(
                                                            "events_parisTimezoneDate",
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </Link>
                ))}
            </div>
        </>
    );
}
